import fullLogo from '@app/assets/fullLogoLight.svg'
import smallLogo from '@app/assets/smallLogoWhite.svg'
import { TextLink } from '@app/components/core/link/TextLink'
import Column from '@app/components/layout/Column'
import { pages } from '@app/util/links'
import { SideBarMenuItem } from './blocks/SideBarMenuItem'
import { faCircleInfo, faUsers } from '@fortawesome/pro-light-svg-icons'
import { Text } from '@app/components/core/typography/Text'
import useMediaQuery from '@app/util/useMediaQuery'
import { useTranslations } from '@i18n/useLanguage'
import { useLocation, useParams } from 'wouter'

export const InitiativeSideBar = () => {
  const [location, navigate] = useLocation()
  const params = useParams<{ id: string }>()
  const isMobile = useMediaQuery()
  const translations = useTranslations().app.dashboard.initiative.sideBar
  return (
    <Column
      alignItems="stretch"
      gap={'2rem'}
      style={{
        //flex: '0 0 12.5rem',
        width: isMobile ? '3.25rem' : '12.5rem',
        padding: isMobile ? '2rem 0.5rem' : '2rem 1rem',
        borderRadius: isMobile ? '0.75rem' : '1.875rem',
        background: 'var(--brand-secondary)',
        position: 'fixed',
        left: isMobile ? 0 : '1.5rem',
        top: isMobile ? '0.5rem' : '1.5rem',
        bottom: isMobile ? '0.5rem' : '1.5rem',
        zIndex: 11,
      }}
    >
      <TextLink to={pages.home} noHover={true} isBold={false}>
        <img
          src={isMobile ? smallLogo : fullLogo}
          alt="Crowdbuilding Logo"
          style={{
            color: 'var(--palette-white)',
            width: isMobile ? '2.25rem' : 'auto',
          }}
          color="var(--palette-white)"
        />
      </TextLink>
      <Column gap={isMobile ? '1.5rem' : '2.5rem'} alignItems="stretch">
        <SideBarMenuItem
          icon={faCircleInfo}
          label={isMobile ? null : translations.about}
          toggled={location === pages.dashboardViewInitiative(params.id)}
          onClick={() => navigate(pages.dashboardViewInitiative(params.id))}
        />
        {/* <Column gap="0.5rem" alignItems="stretch" style={{ flexGrow: 0 }}>
          {!isMobile && (
            <Text.ExtraSmall
              color="var(--palette-blue-200)"
              style={{
                fontSize: '0.5625rem',
              }}
            >
              {translations.communityTools.toLocaleUpperCase()}
            </Text.ExtraSmall>
          )}
          <SideBarMenuItem
            icon={faMapPin}
            label={isMobile ? null : translations.pinBoard}
            toggled={false}
            disableLabel="Coming soon!"
            onClick={function (): void {
              throw new Error('Function not implemented.')
            }}
          />
        </Column> */}
        <Column gap="0.5rem" alignItems="stretch" style={{ flexGrow: 0 }}>
          {!isMobile && (
            <Text.ExtraSmall
              color="var(--palette-blue-200)"
              style={{
                fontSize: '0.5625rem',
              }}
            >
              {translations.manage.toLocaleUpperCase()}
            </Text.ExtraSmall>
          )}
          <SideBarMenuItem
            icon={faUsers}
            label={isMobile ? null : translations.people}
            toggled={
              location === pages.dashboardManagePeopleInitiative(params.id)
            }
            onClick={() =>
              navigate(pages.dashboardManagePeopleInitiative(params.id))
            }
          />
        </Column>
      </Column>
    </Column>
  )
}
